// extracted by mini-css-extract-plugin
export var footer = "_n5-5";
export var fulfillmentInput = "_n5-0";
export var shipDateInput = "_n5-1";
export var shipmentModal = "_n5-2";
export var shipmentModalContent = "_n5-3";
export var tableContainer = "_n5-4";